import clsx from 'clsx';

import { getUnreadLabel } from './utils';

interface TeamChannelPreviewProps {
  name: string;
  date?: string;
  unreadCount?: number;
}

export const TeamChannelPreview = ({
  name,
  date = '',
  unreadCount,
}: TeamChannelPreviewProps) => {
  const unreadLabel = getUnreadLabel(unreadCount);

  return (
    <div
      className={clsx('channel-preview__item', {
        bold: !!unreadLabel,
      })}
    >
      <div className="channel-preview__name">{`# ${name}`}</div>
      {!!date && <div className="channel-preview__date">{`# ${date}`}</div>}
      {unreadLabel && (
        <span className="channel-preview__unread-count">{unreadLabel}</span>
      )}
    </div>
  );
};
